import { render } from "./CustomShiftsPage.vue?vue&type=template&id=7350aeea&scoped=true&ts=true"
import script from "./CustomShiftsPage?vue&type=script&lang=ts"
export * from "./CustomShiftsPage?vue&type=script&lang=ts"

import "./CustomShiftsPage.vue?vue&type=style&index=0&id=7350aeea&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7350aeea"]])

export default __exports__